import { useEffect } from 'react';

const useDocumentTitle = (title: string, template = '%s | LifeHub'): void => {
  useEffect(() => {
    document.title = template.replace(/%s/gi, title);
  }, [template, title]);
};

export default useDocumentTitle;
